export const component = import('./SetupIndex.vue');
